// extracted by mini-css-extract-plugin
export default {"suggestionsMessage":"webpack-concepts-Extraction-FormBuilder-SuggestionsMessage-module__suggestionsMessage"};